import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=c1b2555c&scoped=true"
import script from "./bindPhone.vue?vue&type=script&lang=js"
export * from "./bindPhone.vue?vue&type=script&lang=js"
import style0 from "./bindPhone.vue?vue&type=style&index=0&id=c1b2555c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b2555c",
  null
  
)

export default component.exports